/**
 * Runtime configuration.
 *
 * Read from `window.__OUTPOST_CONFIG__`, which `serve.ts` writes at container
 * start. Baking the API URL into the bundle would mean rebuilding the image for
 * every environment; this way one image is promoted from staging to production
 * unchanged.
 */

export interface RuntimeConfig {
  /** Base URL of the dashboard API. Empty means same-origin. */
  apiUrl: string;
  /** Base URL of the ingest service, shown in setup instructions. */
  ingestUrl: string;
  /** DSN the dashboard uses to report its own errors. */
  dsn: string;
}

declare global {
  interface Window {
    __OUTPOST_CONFIG__?: Partial<RuntimeConfig>;
  }
}

const injected = typeof window !== 'undefined' ? window.__OUTPOST_CONFIG__ : undefined;

export const config: RuntimeConfig = {
  // Vite env vars are the development path; the injected object wins in a container.
  apiUrl: injected?.apiUrl || import.meta.env.VITE_OUTPOST_API_URL || '',
  ingestUrl:
    injected?.ingestUrl || import.meta.env.VITE_OUTPOST_INGEST_URL || 'http://localhost:8081',
  dsn: injected?.dsn || import.meta.env.VITE_OUTPOST_DSN || '',
};

/**
 * The API as an absolute URL, for instructions that are pasted somewhere else.
 *
 * `apiUrl` may be empty or a bare path, which means something only to a page
 * served from the same origin; a CI job needs the host spelled out.
 */
export function absoluteApiUrl(): string {
  try {
    return new URL(config.apiUrl || '/', window.location.origin).href.replace(/\/+$/, '');
  } catch {
    return 'https://outpost.example.com';
  }
}
